export const VITE_AUTH_JWT = import.meta.env.VITE_AUTH_JWT;
export const VITE_JWT_DO_NOT_UPLOAD = import.meta.env.VITE_JWT_DO_NOT_UPLOAD;
export const VITE_BASE_API_URL = import.meta.env.VITE_BASE_API_URL;
export const VITE_BEEPQUEST_BASE_URL = import.meta.env.VITE_BEEPQUEST_BASE_URL;
export const VITE_BEEPQUEST_SECRET = import.meta.env.VITE_BEEPQUEST_SECRET;
export const VITE_APPSYNC_ENDPOINT = import.meta.env.VITE_APPSYNC_ENDPOINT;
export const VITE_APPSYNC_APIKEY = import.meta.env.VITE_APPSYNC_APIKEY;
export const VITE_APPSYNC_REGION = import.meta.env.VITE_APPSYNC_REGION;
export const VITE_USER_POOL_ID = import.meta.env.VITE_USER_POOL_ID;
export const VITE_USER_POOL_WEB_CLIENT_ID = import.meta.env
  .VITE_USER_POOL_WEB_CLIENT_ID;
export const VITE_OAUTH_DOMAIN = import.meta.env.VITE_OAUTH_DOMAIN;
export const VITE_URL = import.meta.env.VITE_URL;
export const VITE_ENABLE_MOCK = import.meta.env.VITE_ENABLE_MOCK;
export const VITE_SENTRY_DNS = import.meta.env.VITE_SENTRY_DNS;
export const VITE_SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT;
export const VITE_CLOUDWATCH_URL = import.meta.env.VITE_CLOUDWATCH_URL;
